import { render } from "./forget-sent.vue?vue&type=template&id=7a840cae&ts=true"
import script from "./forget-sent.vue?vue&type=script&lang=ts"
export * from "./forget-sent.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__